import React, { Component } from 'react';
import ThemedIcon from '../../components/common/ThemedIcon';
import { connect } from 'react-redux';
import styled, { css, keyframes } from 'styled-components';
import { FaTimes as RemoveIcon, FaAngleRight } from 'react-icons/fa';

import {
  dashboardApi,
  getConsultationSummary,
  homeTab,
  fetchConsultationBlocker,
  consultationTab,
  getLabTestsCart,
  addPackageToCart,
  selectLabPartner,
  getHraPdfUrl,
  resetHra,
  fitnessDetUser,
  getNutritionDetails,
  popup,
  getCultPass,
  fetchUpgradePackages,
  markSmartSummaryShown,
  userInfo,
} from '../../services';
import {
  logout,
  openFileViewer,
  setCurrentActiveTab,
  setFitcoinsBalance,
  setManageDependentLink,
  togglePrescriptionPopup,
} from '../../actions';

import LoadingSkeleton from '../../components/common/Skeleton/HomeContainer';
import { BoldText, Text, ButtonText } from '../../components/common/Text';
import StyledTappable from '../../components/common/StyledTappable';
import HomeActionCard from '../../components/home/HomeActionCard';
import RewardsCard from '../../components/home/RewardsCard';
import ReferCard from '../../components/home/ReferCard';
import {
  FadeInTransition,
  FlyInTransition,
} from '../../components/transitions/transitions';
import Modal from '../common/Modal';
import UploadPrescription from '../consultation/UploadPrescription';
import { RegularText } from '../../components/common/Text';
import { FitcoinButton } from '../../components/common/Buttons';
import WaterLogCard from '../../components/home/WaterLogCard';
import NewHomeActionCard from '../../components/home/NewHomeActionCard';
import HospitalizationModal from '../common/HospitalizationModal';
import EcardsContainer from './EcardsContainer';
import GymHomeCard from '../../components/gym-bookings/home-card';
import ContactSupport from '../../components/home/ContactSupport';
import UpSellCard from '../../components/common/UpSellCard';
import UpsellBookingFlowModals from '../upsell/ahc/UpsellBookingFlowModals';
import EAPSection from '../../components/home/EAPSection';
import DependentCard from '../../components/home/DependentCard';
import PrescriptionPopup from '../consultation/PrescriptionPopup';
import SnackBar from '../consultation/SnackBar';
import AdditionalCards from '../../components/home/AdditionalCards';
import SwitchBenefitModal from '../common/SwitchBenefitModal';
import initializeFreshDesk from '../../utils/freshchat';
import { logEvent } from '../../utils/logEvent';
import DisclaimerPopup from '../../components/common/DisclaimerPopup';
import ClaimInstructionsModal from '../../components/common/ClaimInstructionsModal';
import ClaimFeedbackBottomSheet from '../../components/claims/ClaimFeedbackBottomSheet';
import GmcClaimsFeedbackBottomSheet from '../../components/claims/GmcClaimsFeedbackBottomSheet';
import { submitClaimReview, submitGmcClaimReview } from '../../services/claims';
import SmartSummaryBottomSheet from '../../components/smart-summary-bottom-sheet/SmartSummaryBottomSheet';

import CheckSymptomsIcon from '../../images/new-home-card-images/CheckSymptoms.png';
import fitcoinLine from '../../images/common/fitcoin-line.png';
import fitcoinIconWhite from '../../images/common/rewardiconwhite.png';
import giftIcon from '../../images/common/gift-gold-icon.svg';
import backgroundPattern from '../../images/common/pattern.png';
import membersIcon from '../../images/home/members.svg';
import DependantIcon from '../../images/home/dependant.svg';
import HealthDataIcon from '../../images/home/health-data-icon.svg';
import HealthDataHero from '../../images/home/health-data-hero.svg';
import notification from '../../images/home/notification.svg';
import navigationButton from '../../images/home/navigation-button.svg';
import CallIcon from '../../images/concierge/call.svg';
import WhatsAppIcon from '../../images/concierge/whatspp.svg';
import ConceirgeBackground from '../../images/concierge/conceirgeBackgrond.svg';
import RightBackIcon from '../../images/lab-test/right-back.svg';
import VisitLogoWhite from '../../images/visit-logo-white.svg';
import labIcon from '../../images/home/lab.svg';
import medIcon from '../../images/home/med.svg';
import Rec4 from '../../images/concierge/Rectangle-Large.svg';
import FitnessCard from '../../images/home/Fitness-Workout.png';
import PodcastCardImage from '../../images/home/Mindfulness-Podcast.png';
import HRACard from '../../components/home/HRACard';
import { myntraSponsorId } from '../../config';
import ImportantLinksGrid from '../../components/home/ImportantLinksGrid';
import NudgeModal from '../../components/home/NudgeModal';
import CardGridModal from '../../components/common/CardGridModal';
import { openLinkInNewTab } from '../../utils';
import { ReactComponent as AhcNudgeIcon } from '../../images/home/wellness/ahc-alert.svg';
import { ReactComponent as ConsultationNudgeIcon } from '../../images/home/wellness/consultation-card.svg';
import clientConfig from '../../clientConfig';

const BodyContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  padding-bottom: 3rem;
  background: #ffffff;
  width: 100svw;
  height: fit-content;
`;

const ModalContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: stretch;
  overflow: hidden;
  background: rgba(0, 0, 0, 0.7);
`;

const ModalBody = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  background-color: rgba(0, 0, 0, 0.9);
  background-image: ${() => `url(${backgroundPattern})`};
  background-repeat: repeat;
  padding: 0.75rem;
  border-radius: 0.625rem 0.625rem 0 0;
`;

const CloseContainer = styled(StyledTappable)`
  align-self: flex-end;
  padding: 0.5rem;
`;

const CloseIcon = styled(RemoveIcon)`
  color: white;
`;

const GiftImage = styled.img`
  width: 4rem;
  margin-bottom: 1.125rem;
`;

const LineSeparator = styled.img`
  width: 10rem;
  margin-bottom: 0.875rem;
`;

const ModalTitle = styled(BoldText)`
  font-size: ${() => `${1.125 * process.env.REACT_APP_FONT_MULTIPLIER}rem`};
  color: white;
`;

const StepsContainer = styled.div`
  align-self: stretch;
  display: flex;
  flex-direction: column;
`;

const StepContainer = styled.div`
  display: flex;
  align-items: flex-start;
  margin: 1rem 0;
`;

const StepNumber = styled(RegularText)`
  font-size: ${() => `${0.875 * process.env.REACT_APP_FONT_MULTIPLIER}rem`};
  border: 1px solid white;
  color: white;
  width: 2rem;
  height: 1.5rem;
  border-radius: 3rem;
`;

const StepTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-left: 1.125rem;
`;

const StepTextTile = styled(Text)`
  font-size: ${() => `${1 * process.env.REACT_APP_FONT_MULTIPLIER}rem`};
  color: white;
`;

const StepTextSubtitleContainer = styled.div`
  display: flex;
  align-items: center;
`;

const StepTextSubtitle = styled(RegularText)`
  font-size: ${() => `${0.75 * process.env.REACT_APP_FONT_MULTIPLIER}rem`};
  text-align: left;
  opacity: 0.6;
  color: white;
`;

const FitcoinIcon = styled.img`
  width: 0.75rem;
  height: 0.75rem;
  margin-left: 0.25rem;
`;

const ArrowIcon = styled(FaAngleRight)`
  color: var(--primary-button, #714fff);
`;

const AdditionalCardContainer = styled.div`
  margin: 20px 0xp 16px 16px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  background: #ffffff;
  border-radius: 12px;
  border: 1px solid #e3e3e3;
`;

const AdditionalCard = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
`;

const SubHeadings = styled.div`
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 150%;
`;

const HospitalizationModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.7);
  width: 100%;
  height: 100%;
`;

const Card = styled.button`
  border: 1px solid #e3e3e3;
  border-radius: 12px;
  text-align: left;
  width: 100%;
`;
const AHCheader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin: 10px 25px;
`;
const AHCHeadText = styled.div`
  color: #000;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%;
`;

const AHCHead2 = styled.div`
  display: flex;
  color: var(--text-primary, #0f0b28);
  text-align: right;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%;
  letter-spacing: 0.25px;
`;

const CardDiv = styled.div`
  cursor: pointer;
  flex-basis: ${(props) => (props.flex ? '48%' : '')};
  margin: 1%;
`;

const Breadcrumb = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  z-index: 12;

  width: 100%;
  height: 48px;
  bottom: 57px;
  background: linear-gradient(
    88.23deg,
    #ffd7b3 1.4%,
    #ffddbe 57.06%,
    #ffb776 112%
  );
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;

  box-shadow: 0px -4px 9px 0px #00000026;
  padding: 0 20px;

  @media (min-width: 1200px) {
    bottom: 0px;
  }
`;

const BreadcrumbContainer = styled.div`
  display: flex;
  flex-direction: row;
  height: 24px;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  // padding: 10px;
`;

const NotificationIcon = styled.img`
  width: 24px;
  height: 24px;
  border-radius: 8px;
`;

const NavigationButton = styled.img`
  width: 20px;
  height: 20px;
  border-radius: 24px;
  // gap: 8px;
`;

const BreadcrumbText = styled.div`
  width: 256px;
  height: 20px;

  font-weight: 700;
  font-size: 14px;
  line-height: 140%;
  letter-spacing: 0px;
  vertical-align: middle;
  color: #3a2ca0;
  // margin-left: -50px;
`;

const ConceirgeContainer = styled.div`
  color: #fff;
  padding: 16px 0px 0px 16px;
  display: flex;
  background-image: url(${ConceirgeBackground});
  background-size: cover;
  background-repeat: no-repeat;
  width: 100%;
  border-radius: 28px 28px 0px 0px;
`;
const ConceirgeTitle = styled.div`
  font-family: Bricolage Grotesque;
  font-weight: 700;
  font-size: 18px;
  line-height: 23px;
  letter-spacing: 0.25%;
`;

const ConceirgeDesc = styled.div`
  font-family: Red Hat Display;
  font-weight: 500;
  font-size: 12px;
  line-height: 15p;
  letter-spacing: 0.25%;
  margin-top: 8px;
`;

const CallContainer = styled.a`
  background: ${(props) => (props.callCta ? '#fff' : '#39C652')};
  color: ${(props) => (props.callCta ? 'var(--primary)' : '#fff')};
  margin-top: 16px;
  font-family: Red Hat Display;
  font-weight: 700;
  font-size: 12px;
  line-height: 120%;
  letter-spacing: 0px;
  vertical-align: middle;
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 6px 12px;
  border-radius: 12px;
`;

const ConceirgeFooter = styled.div`
  background: linear-gradient(180deg, #f7f3ec 0%, #fadfba 100%);
  display: flex;
  align-items: start;
  border-radius: 0px 0px 12px 12px;
  font-family: Red Hat Display;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.25%;
  padding: 6px 16px;
  position: relative;
  z-index: 2;
`;

const slideLeft = keyframes`
  from {
    transform: translateX(20px);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
`;

const LottieInnerContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  position: relative;
  z-index: 3;
`;

const FooterContainer = styled.div`
  ${(props) =>
    props.animate &&
    css`
      animation: ${slideLeft} 0.3s ease-in-out;
    `}
  display: flex;
  width: 100%;
  border: 1px solid #d0b6ab;
  border-radius: 0px 0px 12px 12px;
`;

const slideInFromLeft = keyframes`
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
`;

const RecScroller = styled.div`
  position: absolute;
  top: ${(props) => props.top || 0}px;
  width: 200%; // double width so content can scroll
  display: flex;
  animation: ${slideInFromLeft} 2s linear infinite;
`;

const RecImage = styled.img`
  width: ${(props) => props.width || '100px'};
`;

const CardScrollContainer = styled.div`
  display: flex;
  gap: 16px;
  overflow-x: auto;
  padding: 0 16px 24px;
  scroll-snap-type: x mandatory;
  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar {
    display: none;
  }
`;

const PopUpPillsContainer = styled.div`
  position: fixed;
  bottom: ${(props) => props.bottomOffset || 0}px;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  max-width: 440px;
  z-index: 39;
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
`;

class HomeContainer extends Component {
  constructor(props) {
    console.log('config', props.sponsorId, myntraSponsorId);
    console.log('myntraSponsorId', myntraSponsorId.includes(props.sponsorId));

    super(props);
    this.getConsoleApiResponse = this.getConsoleApiResponse.bind(this);
    this.markInitialLoadDone = this.markInitialLoadDone.bind(this);
    this.state = {
      dashboardApiLoaded: false,
      initialLoad: {
        dashboard: false,
        careConsole: false,
        homeConsole: false,
      },
      servicesCards: [],
      fitCoinsCards: [],
      additionalCards: [],
      importantLinksNew: null,
      importantLinkModal: null,
      claimChecklistCard: null,
      nudgeModal: null,
      popUpCardData: [],
      emailVerificationAvailable: false,
      blockers: {},
      tinderBenefits: null,
      quickActionCards: [],
      hraCard: [
        {
          cardType: 'hra-card',
          collapse: false,
          pendingConsult: 0,
          cardDirective: {
            actionType: 'native',
            action: {
              redirectTo: 'hra',
            },
          },
          labelIcon: 'search',
          label: 'Metabolic Profile',
          labelInfo: 'Find a doctor nearby',
          actionIcon: 'arrow',
        },
      ],
      opdCards: [],
      inviteCards: [],
      showModal: false,
      modalVisible: false,
      showPendingConsultBlocker: false,
      pendingConsult: {
        doctorId: '',
        consultationId: '',
        doctorImg: '',
        doctorName: '',
        dateLabel: '',
      },
      enrollmentCard: [],
      ahcCard: [],
      healthContentCards: [],
      consoleCards: [],
      showHospitalizationModal: false,
      showOPDClaimModal: false,
      showPendingHospilationBlocker: false,
      showPendingOPDClaimBlocker: false,
      htmlCards: [],
      hraDownloadableLink: '',
      policyCards: '',
      showGymCard: false,
      cultPass: {},
      fulfillmentDetails: null,
      onlyClaims: false,
      ecashless: false,
      subscriptionCards: [],
      showPrePostButton: 0,
      showCashlessClaimButton: true,
      showReimbusementClaimButton: true,
      blockerPopups: [],
      showBlockerModal: false,
      hcpCard: null,
      showSnackBar: false,
      ahcCards: [],
      upgradeOrderPackages: null,
      upgradeOrderPackagesList: [],
      upsellCtaLoading: null,
      preBookedCard: [] || null,
      hcpReportStatus: null,
      diseaseQues: 0,
      cultCard: null,
      hospitalisationKeys: {
        gmcServiceFlow: null,
        gmcApiFlow: null,
        treatmentCategory: '',
      },
      animate: false,
      showFirstContainer: true,
      active: 0,
      animateRecs: true,
      axisSupportCard: [],
      eapCards: null,
      dependentCards: null,
      showDisclaimerPopup: false,
      claimFeedbackData: null,
      showFeedbackSnackbar: false,
      showFeedbackBottomSheet: false,
      gmcFeedbackData: null,
      showGmcFeedbackBottomSheet: false,
      showSmartSummarySheet: false,
    };
    this.interval = null;
    this.upsellBookingFlowRef = React.createRef();
  }

  markInitialLoadDone(key) {
    this.setState((prev) => {
      const initialLoad = { ...(prev.initialLoad || {}) };
      initialLoad[key] = true;
      const done =
        initialLoad.dashboard &&
        initialLoad.careConsole &&
        initialLoad.homeConsole;
      return {
        initialLoad,
        dashboardApiLoaded: done,
      };
    });
  }

  handleFeedbackSnackbarTap = () => {
    this.setState({ showFeedbackBottomSheet: true });
  };

  handleFeedbackSnackbarDismiss = () => {
    this.setState({ showFeedbackSnackbar: false });
  };

  handleFeedbackBottomSheetClose = () => {
    this.setState({
      showFeedbackBottomSheet: false,
      showFeedbackSnackbar: false,
    });
  };

  handleFeedbackSubmit = async (body) => {
    await submitClaimReview(body, this.props.authToken);
    this.getConsolePopup();
  };

  handleGmcFeedbackBottomSheetClose = () => {
    this.setState({ showGmcFeedbackBottomSheet: false, gmcFeedbackData: null });
  };

  // --- Smart summary bottom sheet ---

  getSmartSummaryData = () =>
    this.props.user?.loginMeta?.smartSummaryData || null;

  /**
   * Refetch login-info on every Home load so smartSummaryData (and the rest
   * of loginMeta) is fresh, then evaluate the sheet using that fresh payload
   * (props from the dispatch below are not yet committed in this tick).
   */
  refreshLoginInfo = () => {
    const { authToken, dispatch } = this.props;
    if (!authToken) return;
    userInfo(authToken)
      .then((data) => {
        dispatch({ type: 'SET_USER_INFO', payload: data });
        this.setNudgeModal(data);
        this.maybeShowSmartSummary(data?.smartSummaryData);
      })
      .catch((err) => {
        console.error('login-info refresh failed', err);
        // Fall back to whatever is already in redux / the dev dummy.
        this.maybeShowSmartSummary();
      });
  };

  // Show whenever login-info returned smartSummaryData. The server owns the
  // frequency/caps (it stops returning the field once they're hit). No
  // client-side cap. mark-shown is fired on CTA interaction, not on show.
  maybeShowSmartSummary = (freshData) => {
    const data = freshData || this.getSmartSummaryData();
    if (!data) return;
    this.setState({ showSmartSummarySheet: true });
  };

  // Tell the server the sheet was acted on — only on a CTA click
  // (close / view report / view supplements).
  markSmartSummaryShownOnCta = () => {
    const caseId = this.getSmartSummaryData()?.caseId;
    markSmartSummaryShown(this.props.authToken, caseId);
  };

  handleSmartSummaryClose = () => {
    this.markSmartSummaryShownOnCta();
    this.setState({ showSmartSummarySheet: false });
  };

  goToSmartReport = (selectedTab) => {
    // caseId is sourced from the login-info API (smartSummaryData), so the
    // opened report/supplements screen gets it directly — no extra lookup.
    const caseId = this.getSmartSummaryData()?.orderId;
    this.markSmartSummaryShownOnCta();
    this.setState({ showSmartSummarySheet: false });
    if (selectedTab === 0) {
      logEvent('For You - View Report CTA Tapped');
    } else if (selectedTab === 2) {
      logEvent('For You - View Supplements CTA Tapped');
    }
    this.props.history.push('/lab-test/view-report', {
      caseId,
      from: '/home',
      selectedTab,
    });
  };

  handleSmartSummaryViewReport = () => this.goToSmartReport(0);
  handleSmartSummaryViewSupplements = () => this.goToSmartReport(2);

  handleGmcFeedbackSubmit = async (body) => {
    await submitGmcClaimReview(body, this.props.authToken);
  };

  componentDidMount() {
    const { location, authToken, userId } = this.props;
    this.setState({
      showDisclaimerPopup:
        !!this.props.user?.loginMeta?.cashlessServicePromotionalBanner,
    });

    if (this.props.loginState !== 'LOGGED_IN' || !this.props.authToken) {
      // Home screen Protected Route
      this.props.history.push('/login');
      return;
    }
    this.refreshLoginInfo();

    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const timeStamp = today.valueOf();
    getNutritionDetails(timeStamp, userId, authToken)
      .then((res) => {
        this.setState({
          currentCals: res.totalToday,
          totalCals: res.remainingCals,
        });
      })
      .catch((err) => {
        console.error(err);
      });

    // Claim feedback now comes from /console/popups API (reimbursement-feedback card)

    if (location.search) {
      const params = new URLSearchParams(location.search);
      const permissionForGoogleFit = params.get('fitnessPermission') === 'true';
      const NoOfSteps = params.get('steps');
      const NoOfSleep = params.get('sleep');
      const data = {
        permissionForGoogleFit,
        currentSteps: NoOfSteps,
        currentSleep: NoOfSleep,
      };
      // dispatch(setGoogleFitPermission(data));
      // this.fitnessSyncReward();
    }
    // GA Tracking
    if (this.props.googleFitnessPermission) {
      if (this.props.location.search) {
        const params = new URLSearchParams(this.props.location.search);
        const permissionForGoogleFit =
          params.get('fitnessPermission') === 'true';
        if (!permissionForGoogleFit) {
          if (
            window.Android !== undefined &&
            window.Android.connectToGoogleFit
          ) {
            window.Android.connectToGoogleFit();
          } else if (
            window.webkit &&
            window.webkit.messageHandlers &&
            window.webkit.messageHandlers.visitIosView
          ) {
            window.webkit.messageHandlers.visitIosView.postMessage(
              JSON.stringify({
                method: 'connectToGoogleFit',
              })
            );
          } else if (window.ReactNativeWebView) {
            window.ReactNativeWebView.postMessage(
              JSON.stringify({
                method: 'CONNECT_TO_GOOGLE_FIT',
              })
            );
          }
        }
      } else {
        if (window.Android !== undefined && window.Android.connectToGoogleFit) {
          window.Android.connectToGoogleFit();
        } else if (
          window.webkit &&
          window.webkit.messageHandlers &&
          window.webkit.messageHandlers.visitIosView
        ) {
          window.webkit.messageHandlers.visitIosView.postMessage(
            JSON.stringify({
              method: 'connectToGoogleFit',
            })
          );
        } else if (window.ReactNativeWebView) {
          window.ReactNativeWebView.postMessage(
            JSON.stringify({
              method: 'CONNECT_TO_GOOGLE_FIT',
            })
          );
        }
      }
    }
    // GA Tracking
    logEvent('Home Tab');
    this.callDashboardApi();
    this.getConsolePopup();
    this.homeTab();
    if (clientConfig?.showUpgradePackagesSection) this.getUpgradePackages();
    this.fetchConsultationBlocker(); //please enable this code for consulation pending blocker
    this.getConsoleApiResponse(); // take the console cards for new design implementation
    // this.fetchSessionId();
    this.props.dispatch(setCurrentActiveTab('home'));

    this.interval = setInterval(() => {
      this.setState({ animate: false, animateRecs: false }, () => {
        setTimeout(() => {
          this.setState((prevState) => ({
            active: (prevState.active + 1) % 3,
            animate: true,
            animateRecs: true,
          }));
        }, 100);
      });
    }, 2000);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  nudgeSessionKey() {
    return `nudge_shown_${this.props.userId}`;
  }

  componentDidUpdate() {
    const { nudgeModal, dashboardApiLoaded } = this.state;
    const visible =
      nudgeModal && dashboardApiLoaded && !this.props.appError?.hasError;
    if (!visible) return;
    try {
      const key = this.nudgeSessionKey();
      if (!sessionStorage.getItem(key)) sessionStorage.setItem(key, '1');
    } catch (e) {
      // sessionStorage unavailable (private mode)
    }
  }

  getFitneesDetailsOfUser = async () => {
    const response = await fitnessDetUser(this.props.authToken);
    if (response.message === 'success') {
      this.setState({
        steps: response.home[0].cards[0].elements[0],
        meals: response.home[0].cards[0].elements[1],
        sleep: response.home[0].cards[0].elements[2],
      });
    }
  };

  getConsolePopup() {
    const { authToken } = this.props;
    popup(authToken)
      .then((res) => {
        this.popUpCardData = res?.popUpCardData;
        const emailVerificationAvailable = res.popUpCardData.some(
          (item) => item.type === 'verify-email'
        );
        const feedbackCard = res.popUpCardData.find(
          (item) => item.type === 'reimbursement-feedback'
        );
        const gmcFeedbackCard = res.popUpCardData.find(
          (item) => item.type === 'gmc-claim-feedback'
        );
        this.setState({
          emailVerificationAvailable,
          popUpCardData: res?.popUpCardData || [],
          ...(feedbackCard
            ? {
                claimFeedbackData: {
                  claim: {
                    reimbursementId: feedbackCard.attributes.reimbursementId,
                    claimStatus: feedbackCard.attributes.claimStatus,
                    procedureName: feedbackCard.attributes.procedureName,
                    statusUpdatedOn: feedbackCard.attributes.statusUpdatedOn,
                  },
                  reviewOptions: feedbackCard.attributes.reviewOptions,
                },
                showFeedbackSnackbar: true,
              }
            : {
                claimFeedbackData: null,
                showFeedbackSnackbar: false,
              }),
          ...(gmcFeedbackCard
            ? {
                gmcFeedbackData: {
                  claimId: gmcFeedbackCard.attributes.claimId,
                  reviewOptions: gmcFeedbackCard.attributes.reviewOptions,
                },
                showGmcFeedbackBottomSheet: true,
              }
            : {
                gmcFeedbackData: null,
                showGmcFeedbackBottomSheet: false,
              }),
        });
      })
      .catch((err) => {
        console.error(err);
      });
  }

  getConsoleApiResponse() {
    const { authToken, showHra } = this.props;
    consultationTab(authToken)
      .then((res) => {
        const services = res?.console?.map((card) => ({
          ...card,
          key: card.cardKey,
        }));
        if (showHra) {
          services?.push(this.state.hraCard[0]);
        }
        const reimbursementDetails = services?.filter(
          (c) => c.cardType === 'reimbursement'
        );
        const reimbursementDetailsObject = reimbursementDetails[0]
          ? reimbursementDetails[0]
          : null;
        const prePostDetails = services?.filter(
          (p) => p.cardType === 'hospitalisation'
        )?.[0];
        this.setState({
          loading: false,
          consoleCards: services,
          htmlCards: services?.filter((s) => s.cardType === 'html'),
          // blockers: res.blockers,
          fulfillmentDetails: reimbursementDetailsObject,
          hospitalisationKeys: {
            gmcApiFlow: prePostDetails?.gmcApiFlow,
            gmcServiceFlow: prePostDetails?.gmcServiceFlow,
            treatmentCategory: prePostDetails?.treatmentCategory,
          },
          showPrePostButton:
            prePostDetails?.prePostInfo?.prePostEnabled || false,
          showCashlessClaimButton: Boolean(
            prePostDetails?.canIntimateClaimForPolicy
          )
            ? true
            : false,
          showReimbusementClaimButton: Boolean(
            prePostDetails?.canSubmitClaimForPolicy
          )
            ? true
            : false,
        });

        if (!reimbursementDetailsObject) {
          this.setState({
            onlyClaims: true,
          });
        }
        this.getHraPdfLink();
      })
      .catch((err) => {
        console.error(err);
        if (
          err?.response?.data?.errorMessage ===
          'You have been blocked to use the app.'
        ) {
          this.props.dispatch(logout(this.props.history));
        }
      })
      .finally(() => {
        this.markInitialLoadDone('careConsole');
      });
  }

  callDashboardApi() {
    const { dispatch, authToken } = this.props;
    dashboardApi(authToken)
      .then((result) => {
        dispatch(setFitcoinsBalance(result.userInfo.walletBalance));
        result.home.forEach((categories) => {
          switch (categories.category) {
            case 'tinder-benefits':
              this.setState({
                tinderBenefits: categories,
              });
              break;
            case 'enrollment-card':
              this.setState({
                enrollmentCard: [categories],
              });
              break;
            case 'ahc':
              this.setState({
                ahcCard: [categories],
              });
              break;
            case 'services':
              this.setState({
                servicesCards: categories.cards,
              });
              break;

            case 'fit-coins':
              this.setState({
                fitCoinsCards: categories.cards,
              });
              break;
            case 'opd-policy':
              this.setState({
                opdCards: categories.cards,
              });
              break;
            case 'fitness-mind':
              this.setState({
                healthContentCards: categories.cards,
              });
              break;
            case 'additional-cards': {
              this.setState({
                additionalCards: categories.cards.filter(
                  (card) => card.cardType !== 'dependentAddCard'
                ),
              });
              const dependentCards = categories.cards.filter(
                (c) => c.cardKey === 'dependent-add-card'
              );

              if (dependentCards.length > 0) {
                this.updateManageDependentLink(dependentCards);
                this.setState({
                  dependentCards: dependentCards[0],
                });
              }
              break;
            }
            case 'invite-earn':
              // this.setState({
              //   inviteCards: categories.cards,
              // });
              break;
            case 'policy-cards':
              this.setState({ policyCards: categories.cards[0].policyCards });
            default:
              break;
          }
        });
        if (result?.userSponsorChanged) {
          // login-info API
          dispatch({
            type: 'RESET_USER',
            authToken: authToken,
          });
          // All Home API Calls
          setTimeout(() => {
            window.location.reload();
          }, 500);
        }
        // this.setState({
        //   dashboardApiLoaded: false,
        // });
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        this.markInitialLoadDone('dashboard');
      });
  }

  fetchCultPass = async (productId) => {
    if (productId && typeof productId === 'number')
      try {
        const data = await getCultPass(this.props.authToken, productId);
        this.setState({ cultPass: data.data.data, showGymCard: true });
      } catch (err) {
        console.error(err);
        // showError(err);
      }
  };

  homeTab = () => {
    homeTab(this.props.authToken)
      .then((res) => {
        const { portals } = res;
        const subscriptions =
          res.home.filter((card) => card?.category === 'subscription')?.[0]
            ?.cards ?? [];
        const preBookingCard = res?.home?.filter(
          (homeCard) => homeCard?.category === 'pre-book-hospital'
        );
        const challenges =
          res.home.filter(
            (homeCard) => homeCard.category === 'challenge-updates'
          )?.[0]?.cards ?? [];
        const portalBlocker = portals?.blocker;
        const prescriptionStatus =
          portalBlocker?.[0]?.cardDirective?.data?.[0]
            ?.prescriptionVerificationStatus;
        const hasPendingPrescription =
          prescriptionStatus === 'upload' || prescriptionStatus === 'rejected';
        const womenWellnessCard =
          res?.home?.filter(
            (homeCard) => homeCard?.category === 'women-wellness'
          )?.[0]?.cards ?? [];
        this.setState({
          subscriptionCards: [
            ...subscriptions,
            ...challenges,
            ...womenWellnessCard,
          ],
          blockerPopups: portalBlocker || [],
          showBlockerModal: !!portalBlocker,
          showSnackBar: !!portalBlocker,
          eapCards: res.home.filter(
            (card) => card?.category === 'eap-program'
          )?.[0],
          importantLinksNew:
            res.home.filter(
              (card) => card?.category === 'important-links-new'
            )?.[0] ?? null,
        });
        if (hasPendingPrescription) {
          this.props.dispatch(togglePrescriptionPopup(true));
        }

        if (preBookingCard) {
          this.setState({
            preBookedCard: preBookingCard,
          });
        }
        if (
          !!res.home.filter(
            (homeCard) => homeCard?.category === 'rex-program'
          )[0]?.cards?.length
        ) {
          const cultCard = res.home
            ?.filter((homeCard) => homeCard?.category === 'rex-program')[0]
            ?.cards.filter((card) => card?.cardType === 'cult')[0];
          this.setState({
            cultCard: cultCard,
          });
          this.props.dispatch({
            type: 'SET_CULT_CARD',
            payload: cultCard?.cardDirective,
          });
          this.fetchCultPass(
            res.home
              ?.filter((homeCard) => homeCard?.category === 'rex-program')[0]
              ?.cards.filter((card) => card?.cardType === 'fitternity')[0]
              ?.productId
          );
        }
        if (
          !!res.home.filter(
            (homeCard) => homeCard?.category === 'info-cards'
          )[0]?.cards?.length
        ) {
          const card = res.home
            ?.filter((homeCard) => homeCard.category === 'info-cards')[0]
            ?.cards.filter((card) => {
              return card.cardKey === 'hcp-program-card';
            })[0];
          this.setState({
            hcpCard: card,
          });
        }
        if (
          res.home?.filter(
            (homeCard) => homeCard.category === 'ahc-lead-packages'
          )[0]?.cards
        ) {
          const card = res.home.filter(
            (homeCard) => homeCard.category === 'ahc-lead-packages'
          );
          if (card[0]?.cards?.[0]?.packages) {
            this.setState({
              ahcCards: card[0],
            });
          }
        }

        this.setState({
          axisSupportCard: res?.home
            ?.filter((s) => s.category === 'axis-contact-card')
            .map((i) => i.cards[0].cardDirective),
        });
      })
      .catch((err) => {
        console.error(err);
        if (
          err?.response?.data?.errorMessage ===
          'You have been blocked to use the app.'
        ) {
          this.props.dispatch(logout(this.props.history));
        }
      })
      .finally(() => {
        this.markInitialLoadDone('homeConsole');
      });
  };

  getUpgradePackages = () =>
    fetchUpgradePackages(this.props.authToken)
      .then((res) => {
        const pkgs = Array.isArray(res?.data?.packages)
          ? res.data.packages
          : [];
        if (!pkgs.length) {
          this.setState({
            upgradeOrderPackages: null,
            upgradeOrderPackagesList: [],
          });
          return;
        }
        this.setState({
          upgradeOrderPackages: res?.data || null,
          upgradeOrderPackagesList: pkgs,
        });
      })
      .catch((err) => {
        console.error(err);
      });
  updateManageDependentLink = (dependentCards) => {
    const { cardDirective } = dependentCards[0];
    this.props.dispatch(
      setManageDependentLink(cardDirective.elements[0].redirectTo)
    );
  };

  startTreament = (
    showSearch,
    pendingConsult,
    cancelledRequest,
    showVerticals,
    verticalId
  ) => {
    const { history, authToken, userId } = this.props;
    if (cancelledRequest > 0) {
      history.push('/consultation/cancel-blocker', {
        requestId: cancelledRequest,
      });
    } else if (pendingConsult > 0) {
      getConsultationSummary(pendingConsult, userId, authToken)
        .then((summary) => {
          console.log('getConsultationSummary', summary);
          const { dateLabel, doctorId, doctorName, doctorImg } =
            summary.consultationInfo;
          this.setState({
            pendingConsult: {
              consultationId: pendingConsult,
              doctorId,
              doctorImg,
              doctorName,
              dateLabel,
            },
            showModal: true,
            showPendingConsultBlocker: true,
          });
        })
        .catch((err) => {
          console.error(err);
        });
    } else {
      history.push('/consultation/online/preview', {
        specialistSearch: false,
        searchType: 'find',
        showSearch,
        showVerticals: showVerticals
          ? showVerticals
          : verticalId
            ? false
            : true,
        verticalId: verticalId,
      });
    }
  };

  findSpecialist = (pendingConsult, cancelledRequest) => {
    const { history, authToken, userId } = this.props;
    const { blockers } = this.state;

    if (blockers.cancelledRequest > 0) {
      this.props.history.push('/consultation/cancel-blocker', {
        requestId: blockers.cancelledRequest,
        goBack: true,
      });
    } else if (blockers.pendingRequestId > 0) {
      this.props.history.push('/consultation/appointment/appointment-status', {
        requestId: blockers.pendingRequestId,
        goBack: true,
      });
    } else {
      history.push('/consultation/preview', {
        specialistSearch: false,
        searchType: 'find',
        from: 'home',
      });
    }
  };

  findDentist = (pendingConsult, cancelledRequest) => {
    const { history, authToken, userId } = this.props;

    history.push('/dental/preview', {
      specialistSearch: false,
      searchType: 'find',
      from: 'home',
    });
  };

  bookTests = () => {
    const { history } = this.props;
    history.push('/lab-test');
  };

  bookCashlessPhysio = () => {
    const { history } = this.props;
    history.push('/cashless-physiotherapy');
  };

  orderMedicine = () => {
    const { history } = this.props;
    history.push('/pharmacy');
  };

  hideModal = () => {
    this.setState({
      showModal: false,
      showHospitalizationModal: false,
      showOPDClaimModal: false,
    });
  };

  closeModal = () => {
    this.setState({ modalVisible: false });
  };

  openRewards = () => {
    const { history } = this.props;
    history.push('/home/rewards');
  };

  showFitcoinModal = () => {
    this.setState({
      showModal: true,
      modalVisible: true,
    });
  };

  requestReimbursement = (ele) => {
    const { fulfillmentDetails, onlyClaims } = this.state;
    const { history } = this.props;
    if (fulfillmentDetails?.fulfillmentDetailsAvailable || onlyClaims) {
      if (ele?.spGlobalReimbursementFlow === 1) {
        history.push('/new-reimbursement/preview', {
          isSPGlobalV2: ele?.spGlobalReimbursementFlowV2 === 1,
        });
      } else history.push('/reimbursement');
    } else {
      history.push('/reimbursement/fulfillment-details', {
        fulfillmentDetailsAvailable: false,
        from: 'normal-flow',
        details: fulfillmentDetails,
        isSAndPFlow: ele?.spGlobalReimbursementFlow === 1,
        isSPGlobalV2: ele?.spGlobalReimbursementFlowV2 === 1,
      });
    }
  };

  medicineOrder = () => {
    const { history, user } = this.props;
    logEvent('Pharmacy Medicine Delivery Booking Card', {
      category: 'Pharmacy',
    });
    history.push('/pharmacy');
  };

  myCashlessVaccination = () => this.props.history.push('/vaccination/preview');

  runAction(ele) {
    const { cardDirective } = ele;
    const { userId, history } = this.props;
    switch (cardDirective.actionType) {
      case 'bot':
        history.push('/bot', {
          chatName: cardDirective.action.text,
          channel: `visit.bot.${userId}`,
          action: cardDirective.action,
        });
        break;
      case 'native':
        switch (cardDirective.action.redirectTo) {
          case 'meal-log':
            logEvent('Meal Tracking Dashboard Card Clicked');
            history.push('/logmeal');
            break;
          case 'hra':
            logEvent('HRA Home Tab Card');
            history.push('/hra');
            break;
          case 'ahc-detail':
            history.push('/lab-test/ahc-package?showCloseButton=false');
            break;
          default:
            break;
        }
        break;
      default:
        break;
    }
  }

  closeUploadModal = () =>
    this.setState({
      showPendingConsultBlocker: false,
    });

  submitUploadModal = (consultationId) =>
    this.props.history.push('/home', {
      consultationId,
    });

  fetchConsultationBlocker = () =>
    fetchConsultationBlocker(this.props.authToken)
      .then((res) => {
        this.setState({
          blockers: res.blockers,
        });
      })
      .catch((err) => {
        console.error(err);
      });

  handleOutsideClick = (e) => {
    if (this.node && this.node.contains(e.target)) {
      return null;
    }
    this.setState({
      showPendingHospilationBlocker: false,
      showPendingOPDClaimBlocker: false,
    });
  };

  showHospitalization(ele) {
    this.setState({
      showHospitalizationModal: true,
      showPendingHospilationBlocker: true,
      ecashless: ele.ecashless,
    });
  }
  showOPDClaim(ele) {
    this.setState({
      showOPDClaimModal: true,
      showPendingOPDClaimBlocker: true,
      ecashless: ele.ecashless,
    });
  }

  openSupport = () => initializeFreshDesk(this.props.user);

  openTicketingSupport = () => {
    const { ticketingEnabled, ticketingUrl } = this.props.config || {};
    const { authToken, user } = this.props;
    logEvent('Customer Support Snackbar Clicked');
    if (ticketingEnabled && ticketingUrl && authToken) {
      window.open(`${ticketingUrl}?token=${authToken.split(' ')[1]}`, '_blank');
    } else {
      initializeFreshDesk(user);
    }
  };

  getHraPdfLink = () =>
    getHraPdfUrl()
      .then((result) => {
        if (result.message === 'success') {
          this.setState({ hraDownloadableLink: result.url });
        }
      })
      .catch((err) => {
        console.error(err);
      });

  runAction(ele) {
    const { cardDirective } = ele;
    const { userId, history } = this.props;
    switch (cardDirective.actionType) {
      case 'bot':
        history.push('/bot', {
          chatName: cardDirective.action.text,
          channel: `visit.bot.${userId}`,
          action: cardDirective.action,
        });
        break;
      case 'native':
        switch (cardDirective.action.redirectTo) {
          case 'meal-log':
            history.push('/logmeal');
            break;
          case 'hra':
            history.push('/hra');
            break;
          default:
            break;
        }
        break;
      default:
        break;
    }
  }

  handleImportantLinkClick(card) {
    const { history } = this.props;
    switch (card?.cardType) {
      case 'physical-wellness':
        history.push('/eap/home?type=physicalWellness');
        return;
      case 'mental-wellness': {
        // note: axis uses window.privy (this is specific for them) do not remove
        if (window.privy) {
          window.privy.postMessage(
            JSON.stringify({ method: 'openMentalWellness' })
          );
        }
        return;
      }
      case 'financial-wellness':
        history.push('/eap/home?type=financialWellness');
        return;
      case 'hospitalisation-mediclaim':
        this.setState({ importantLinkModal: card });
        return;
      default:
        break;
    }
  }

  handleImportantLinkSubCardClick(card) {
    const { history, dispatch } = this.props;
    switch (card?.cardType) {
      case 'hospital-list':
        this.setState({ importantLinkModal: null });
        history.push('/hospitalization/hospitals-list');
        return;
      case 'claim-checklist':
        this.showHospitalization(card);
        this.setState({ claimChecklistCard: card });
        return;
      default:
        break;
    }
    if (!card?.redirectTo) return;
    dispatch(
      openFileViewer({
        contentUrl: card.redirectTo,
        type: 'pdf',
        title: card.title || 'Document',
      })
    );
  }

  setNudgeModal(data) {
    try {
      if (sessionStorage.getItem(this.nudgeSessionKey())) return;
    } catch (e) {
      // sessionStorage unavailable (private mode)
    }
    const ahc = data?.ahcPrompt;
    const cons = data?.consultationPrompt;
    let nudgeModal = null;
    if (ahc && ahc.redirectUrl) {
      nudgeModal = {
        type: 'ahc',
        text: ahc.title,
        ctaLabel: 'Book Now',
        redirectUrl: ahc.redirectUrl,
      };
    } else if (cons && cons.verticalId) {
      nudgeModal = {
        type: 'consultation',
        text: cons.title,
        ctaLabel: 'Schedule Now',
        verticalId: cons.verticalId,
      };
    }
    this.setState({ nudgeModal });
  }

  handleResetHra() {
    resetHra()
      .then((res) => {
        // console.log(res, 'reset is done for hra');
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        this.props.history.push('/hra');
      });
  }

  handleCultClick(redirect, userDetails, planDetails, redirectUrl) {
    const { history } = this.props;
    switch (redirect) {
      case 'cityselection':
        return history.push('/cult/select-city', {
          from: 'home',
        });
      case 'planselection':
        return history.push('/cult/select-plan');
      case 'inprogress':
        return history.push('/cult/activation-status');
      case 'booknow':
        window.open(redirectUrl);
      default:
        // Handle default case if necessary
        break;
    }
  }

  render() {
    const {
      history,
      showFitCoins,
      showWaterTracking,
      isPrescriptionPopUpOpen,
      showHra,
      authToken,
      dispatch,
      showSwitchBenefitModal,
      entityId,
    } = this.props;
    const {
      importantLinksNew,
      importantLinkModal,
      claimChecklistCard,
      nudgeModal,
      emailVerificationAvailable,
      servicesCards,
      fitCoinsCards,
      opdCards,
      quickActionCards,
      hraCard,
      inviteCards,
      showModal,
      modalVisible,
      showPendingConsultBlocker,
      pendingConsult,
      tinderBenefits,
      enrollmentCard,
      ahcCard,
      additionalCards,
      healthContentCards,
      consoleCards,
      showHospitalizationModal,
      showOPDClaimModal,
      showPendingHospilationBlocker,
      showPendingOPDClaimBlocker,
      htmlCards,
      hraDownloadableLink,
      policyCards,
      subscriptionCards,
      blockerPopups,
      showBlockerModal,
      hcpCard,
      showSnackBar,
      ahcCards,
      upgradeOrderPackages,
      upgradeOrderPackagesList,
      preBookedCard,
      dashboardApiLoaded,
      cultCard,
      showPrePostButton,
      showCashlessClaimButton,
      showReimbusementClaimButton,
      ecashless,
      cultPass,
      hospitalisationKeys,
      axisSupportCard,
      dependentCards,
      popUpCardData,
    } = this.state;
    const block =
      blockerPopups &&
      blockerPopups.length &&
      blockerPopups[0].cardDirective.data[0];
    // const responseData = this.props.location?.state?.responseData;
    const symptomsCard = consoleCards.filter((c) => c.cardType === 'sym-check');

    const renderHealthContentCards = (cards) => {
      return cards.map((card) => {
        switch (card.cardKey) {
          case 'tik-podcast':
            return (
              <button
                onClick={() =>
                  this.props.history.push('/health-content/podcasts-home')
                }
                className="mb-20px"
              >
                <img src={PodcastCardImage} alt=""></img>
              </button>
            );
          case 'tik-album':
            return (
              <button
                onClick={() =>
                  this.props.history.push('/health-content/fitness-home')
                }
                className="mb-20px"
              >
                <img src={FitnessCard} alt=""></img>
              </button>
            );
          default:
            return null;
        }
      });
    };

    const renderSubscriptionCards = (cards) => {
      return cards.map((card) => {
        const sentence =
          card?.bottomDescription && card?.bottomDescription.split(/\.(.+)/);

        const replacedText =
          card?.description &&
          card?.description.replace(
            '{visit-logo}',
            `<img src="${VisitLogoWhite}" alt="Visit Logo" style="width:60px; height:60px; vertical-align:middle; display:inline; margin-left:4px;" />`
          );
        switch (card.cardKey) {
          case 'axis-enrolment-card':
            return (
              <button
                onClick={() => {
                  window.open(card.cardDirective.action.redirectTo);
                }}
                className="mb-20px"
              >
                <img
                  src={card.link.split('imageLink=')[1]}
                  alt={card.cardKey}
                ></img>
              </button>
            );
          case 'axis-reminder-card':
            return (
              <button
                // onClick={() => {
                //   window.open(card.cardDirective.action.redirectTo);
                // }}
                className="mb-20px pointer-events-none"
              >
                <img
                  src={card.link.split('imageLink=')[1]}
                  alt={card.cardKey}
                ></img>
              </button>
            );
          case 'axis-whatsapp-bot-card':
            return (
              <button
                onClick={() => {
                  window.open(card.cardDirective.action.redirectTo);
                }}
                className="mb-20px pointer-events-none"
              >
                <img
                  src={card.link.split('imageLink=')[1]}
                  alt={card.cardKey}
                ></img>
              </button>
            );
          case 'happiness-challenge-card':
            return (
              <button
                onClick={() => {
                  window.open(card.cardDirective.action.redirectTo);
                }}
                className="mb-20px"
              >
                <img
                  src={card.link.split('imageLink=')[1]}
                  alt={card.cardKey}
                ></img>
              </button>
            );
          case 'cashless-savings':
            return (
              <div
                className="max-w-sm mx-auto overflow-hidden shadow-lg"
                style={{
                  background: '#FFEFD9',
                  borderRadius: '10px',
                }}
                onClick={() =>
                  history.push('reimbursement/cashless-network-savings')
                }
              >
                <div
                  className=" text-textbox"
                  style={{
                    backgroundImage: `url(${card.img})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    borderRadius: '12px',
                    paddingTop: '16px',
                  }}
                >
                  <div
                    className="text-title-s font-bold"
                    style={{
                      background:
                        'linear-gradient(90.54deg, #FFF1C7 0.11%, #FFDF7D 68.28%, #FFCC31 99.91%)',
                      width: 'fit-content',
                      boxShadow: '0px 4px 4px 0px #170B47',
                      color: '#29196F',
                      borderRadius: '0px 12px 12px 0px',
                      padding: '2px 12px 2px 16px',
                    }}
                  >
                    {card.title}
                  </div>
                  <div
                    className="text-title-m font-bold pl-16px"
                    dangerouslySetInnerHTML={{
                      __html: replacedText,
                    }}
                  ></div>
                  <p className="text-header-l font-bolder pl-16px">
                    - ₹ {card.lossAmount}
                  </p>{' '}
                </div>

                <div
                  className="p-4 font-medium text-body-s"
                  style={{
                    color: '#1F1D1E',
                    padding: '12px 8px',
                  }}
                >
                  <p className="text-sm font-medium text-gray-800">
                    {sentence[0]}.
                  </p>
                  <p className="text-sm text-gray-700 mt-1">{sentence[1]}</p>
                </div>
              </div>
            );
          case 'dependent-add-card':
          case 'oracle-enroll-card':
            return (
              <button
                onClick={() => {
                  window.open(card?.cardDirective?.action.redirectTo);
                }}
                className="mb-20px"
              >
                <img
                  src={card?.link?.split('imageLink=')[1]}
                  alt={card.cardKey}
                ></img>
              </button>
            );
          case 'joye-card':
            return (
              <button
                onClick={() => {
                  history.push('/joye/intro');
                }}
                className="mb-20px"
              >
                <img
                  src={card?.link?.split('imageLink=')[1]}
                  alt={card.cardKey}
                ></img>
              </button>
            );
          case 'health-assistant':
            const cardInfo = card.cardInfo;
            console.log('cardInfo.bottomBanner', cardInfo);
            const contactInfo = cardInfo.contactInfo;
            const whatsappInfo = cardInfo.whatsappInfo;
            if (!cardInfo?.bottomBannerItems) return;
            const currentCard = cardInfo?.bottomBannerItems[this.state.active];
            return (
              <div className="max-w-sm mx-18px overflow-hidden shadow-lg">
                <ConceirgeContainer
                  onClick={() => this.props.history.push('/conceirge/home')}
                >
                  <div className="pb-20px">
                    <ConceirgeTitle>{cardInfo.title}</ConceirgeTitle>
                    <ConceirgeDesc>{cardInfo.description}</ConceirgeDesc>
                    <div className="flex items-center gap-8px">
                      <CallContainer
                        callCta
                        href={`tel:${contactInfo?.contactNumber}`}
                      >
                        <ThemedIcon src={CallIcon} alt="call" />
                        <div>{contactInfo.buttonText}</div>
                      </CallContainer>
                      <CallContainer
                        target="_blank"
                        rel="noopener noreferrer"
                        href={`https://wa.me/${whatsappInfo.whatsappNumber}`}
                      >
                        <img src={WhatsAppIcon} alt="call" />
                        <div>{whatsappInfo.buttonText}</div>
                      </CallContainer>
                    </div>
                  </div>
                  <img
                    src={cardInfo.heroImage}
                    alt="hero-image"
                    height={50}
                    width={150}
                  />
                </ConceirgeContainer>
                <FooterContainer animate={this.state.animate}>
                  <ConceirgeFooter>
                    <RecScroller top={10}>
                      <RecImage src={Rec4} alt="rec-1" />
                      <RecImage src={Rec4} alt="rec-1" />
                    </RecScroller>
                    <LottieInnerContainer>
                      <img
                        src={currentCard?.bannerImg}
                        alt="banner-image"
                        width={32}
                        height={32}
                      />
                      <div>{currentCard?.bannerText}</div>
                    </LottieInnerContainer>
                    <RecScroller top={50}>
                      <RecImage src={Rec4} alt="rec-2" width="80px" />
                      <RecImage src={Rec4} alt="rec-2" width="80px" />
                    </RecScroller>
                  </ConceirgeFooter>
                </FooterContainer>
              </div>
            );
          case 'no-action':
            console.log('no-action card', card);
            return (
              <a
                href={
                  card?.cardDirective?.actionType === 'externalWebview' &&
                  card?.cardDirective?.action?.redirectTo
                }
                target="_blank"
                rel="noreferrer"
              >
                <img src={card.link.split('imageLink=')[1]} alt="link"></img>
              </a>
            );
          case 'fitpass':
            return (
              <button
                key={card.cardKey}
                className="mb-20px w-full"
                onClick={() => history.push('/fit-pass')}
              >
                <img
                  src={card.imageUrl}
                  alt={card.cardKey}
                  className="w-full"
                />
              </button>
            );
          case 'mamily-banner':
            return (
              <button key={card.cardKey} className="w-full">
                <img src={card.link} alt={card.cardKey} className="w-full" />
              </button>
            );
          case 'women-wellness-card':
            return (
              <button
                key={card.cardKey}
                className="mb-20px w-full"
                onClick={() => {
                  window.open(card.cardDirective.action.redirectTo);
                }}
              >
                <img
                  src={card.link.split('imageLink=')[1]}
                  alt={card.cardKey}
                  className="w-full"
                />
              </button>
            );
          default:
            return null;
        }
      });
    };

    const renderActionsCard = (ele, idx) => {
      switch (ele.cardType) {
        case 'pharmacy':
          if (ele.showPharmacy) {
            return (
              <HomeActionCard
                onTap={() => this.orderMedicine(ele)}
                title={ele.label}
                icon={medIcon}
                offer={ele.offer}
                discountText={ele.labelBanner}
                earnBadge={ele.ftLabel && ele.ftLabel.trim() !== ''}
              />
            );
          }
          return;
        case 'lab-tests':
          return (
            <HomeActionCard
              onTap={this.bookTests}
              title={ele.label}
              icon={labIcon}
              offer={ele.offer}
              discountText={ele.labelBanner}
              earnBadge={ele.ftLabel && ele.ftLabel.trim() !== ''}
            />
          );
        default:
          return false;
      }
    };

    const renderInviteCard = (ele, idx) => {
      switch (ele.cardType) {
        case 'ftInvite':
          return <ReferCard key={idx} onTap={() => history.push('/refer')} />;
        default:
          return false;
      }
    };
    const renderFitcoinCard = (ele, idx) => {
      switch (ele.cardType) {
        case 'claim-coins':
          return (
            <RewardsCard
              key={idx}
              onSeeAllTapped={this.openRewards}
              onKnowMoreTapped={this.showFitcoinModal}
            />
          );
        default:
          return false;
      }
    };
    const renderEnrollmentCard = (ele, idx) => {
      return (
        <div
          className="border border-txtsecondary-shades7 m-8px bg-textbox rounded-8 cursor-pointer"
          onClick={() => {
            window.location.assign(
              ele.cards[0].cardDirective.action.redirectTo
            );
          }}
          style={{ width: '90%', marginLeft: '5%', marginRight: '5%' }}
        >
          <div className="p-20px flex flex-row justify-between items-center">
            <div className="mr-16px">
              <p className="text-body-l font-semibold text-txtlight mb-12px">
                {ele.title}
              </p>
              <p className="text-body-s font-medium text-txtlight">
                {ele.text}
              </p>
            </div>
            <img
              src={ele.image}
              alt="enroll"
              style={{
                width: '30%',
              }}
            />
          </div>
          <div className="border-t border-txtsecondary-shades7 p-20px flex flex-row items-center justify-center">
            <img
              src={membersIcon}
              alt="enroll"
              style={{
                height: '20px',
              }}
            />
            <p className="text-body-l font-semibold text-primary ml-8px">
              {ele.buttonText}
            </p>
          </div>
        </div>
      );
    };

    const renderAhcCard = (ele, idx) => {
      const url = new URL(ele.cards.cardDirective.action.redirectTo);
      return (
        <div
          // className="border border-txtsecondary-shades7 bg-textbox rounded-8 cursor-pointer"
          className="cursor-pointer"
          onClick={() => {
            // window.location.assign(ele.cards.cardDirective.action.redirectTo);
            history.push(url.searchParams.get('rt'));
            logEvent('Funnel Home Tab AHC Card Clicked');
          }}
        >
          <img
            src={ele.cards.link.split('=')[1]}
            // style={{ height: '40%', width: '100%' }}
            alt="ahc"
          />
        </div>
      );
    };

    const renderAhcCards = (ele, idx) => {
      return (
        <CardDiv
          onClick={() => {
            logEvent('Funnel Native AHC Card Clicked', {
              packageId: ele.packageId,
            });
            history.push('/lab-test/ahcPackageDetails', {
              packageId: ele.packageId,
            });
          }}
          flex={ahcCards.length > 1 ? true : false}
        >
          <img
            src={
              ahcCards.length == 1
                ? ele.bannerLandscapeImage
                : ele.bannerPortraitImage
            }
            alt="ahc"
          />
        </CardDiv>
      );
    };

    const setupCartAndNavigate = (cardData, destination, ctaType) => {
      const { packageId, partnerId } = cardData || {};
      let addedCartItem;
      if (!packageId) return;

      this.setState({
        upsellCtaLoading: {
          packageId,
          destination,
          ctaType,
        },
      });

      getLabTestsCart(this.props.authToken)
        .then((res) => {
          const cartId = res.cartId;
          const cartItems = Array.isArray(res.cart) ? res.cart : [];
          const packageAlreadyInCart = cartItems.some(
            (item) =>
              item?.packageId != null &&
              String(item.packageId) === String(packageId)
          );

          const addIfNeeded = packageAlreadyInCart
            ? Promise.resolve()
            : addPackageToCart(cartId, packageId, this.props.authToken)
                .then((res) => (addedCartItem = res.cartItem.cartItemId))
                .catch((err) => {
                  if (err?.response?.status === 400) return;
                  throw err;
                });

          return addIfNeeded
            .then(() => {
              if (partnerId) {
                return selectLabPartner(
                  cartId,
                  partnerId,
                  null,
                  this.props.authToken
                );
              }
            })
            .then(() => ({ cartId }));
        })
        .then(({ cartId }) => {
          if (ctaType === 'book') {
            this.upsellBookingFlowRef.current?.start({
              cartId,
              packageId,
              visitType: 'home',
              bookingFor: 'AHC',
              onComplete: ({ cartId: cId, patient, selectedSlot }) => {
                history.push('/ahc-upsell/order-summary', {
                  cartId: cId,
                  from: 'upsell-home',
                  patient,
                  selectedSlot,
                });
              },
            });
            return;
          }

          history.push(destination, {
            packageId,
            partnerId,
            cartId,
            addedCartItem,
          });
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.setState({ upsellCtaLoading: null });
        });
    };

    const handleUpsellViewDetails = (cardData) => {
      setupCartAndNavigate(cardData, '/ahc-upsell/package-details', 'details');
    };

    const handleUpsellBookNow = (cardData) => {
      setupCartAndNavigate(cardData, '/ahc-upsell/package-details', 'book');
    };

    const renderUpSellCards = (ele, _, arr) => {
      const loadingKey = this.state.upsellCtaLoading;
      const isThisCardLoading = loadingKey?.packageId === ele?.packageId;
      return (
        <UpSellCard
          cardData={ele}
          totalCards={arr.length}
          onViewDetails={handleUpsellViewDetails}
          onBookNow={handleUpsellBookNow}
          isLoading={!!isThisCardLoading}
          loadingCta={
            loadingKey?.ctaType === 'book'
              ? 'book'
              : loadingKey?.ctaType === 'details'
                ? 'details'
                : null
          }
        />
      );
    };

    const renderAdditionalCards = (ele, idx) => {
      let url;
      let openInSameTab = false;
      try {
        if (
          ele.cardType !== 'sponsor-card' &&
          (ele.cardDirective.action || {}).redirectTo
        ) {
          url = new URL((ele.cardDirective.action || {}).redirectTo);
          openInSameTab = (ele.cardDirective.action || {}).openInSameTab;
        }
      } catch (err) {
        console.error(err);
      }
      if (ele.cardType === 'html') {
        const imageSrc = ele?.link?.split('=')?.[1];
        if (!imageSrc) return null;
        return (
          <div style={{ margin: '0px 5%' }}>
            <div
              className="cursor-pointer my-16px mx-auto"
              onClick={() => {
                if (url && !openInSameTab) {
                  window.open(url, '_blank');
                } else if (url) {
                  window.location.assign(url);
                }
              }}
            >
              <img
                src={imageSrc}
                alt={ele.cardKey || 'html-card'}
                style={{
                  display: 'block',
                  width: '100%',
                  objectFit: 'contain',
                }}
              />
            </div>
          </div>
        );
      }

      if (ele.cardType === 'sponsor-card') {
        return (
          <div style={{ width: '90%', marginLeft: '5%', marginRight: '5%' }}>
            <div
              className="cursor-pointer my-16px mx-auto"
              onClick={() => {
                if (
                  ele.cardDirective.actionType === 'pwa-redirection' &&
                  ele.cardDirective.action.redirectTo
                ) {
                  this.props.history.push(ele.cardDirective.action.redirectTo);
                }
              }}
            >
              <img
                src={ele.imageUrl}
                // style={{ height: '40%', width: '100%' }}
                alt="sponsor-banner"
              />
            </div>
          </div>
        );
      }
      return (
        <AdditionalCardContainer style={{ width: '90%', marginLeft: '5%' }}>
          <AdditionalCard>
            <div className="border-b border-customE5E9FE">
              <div className="p-20px pr-16px">
                <div>
                  <p
                    style={{
                      color: '#0F0B28',
                      fontSize: '14px',
                      fontWeight: '600',
                    }}
                  >
                    {ele.cardInfo.heading}
                  </p>
                </div>
                <div className="flex flex-row items-center justify-center">
                  <p
                    style={{
                      fontSize: '12px',
                      color: '#72777A',
                      textAlign: 'start',
                      marginRight: '34px',
                      lineHeight: '150%',
                    }}
                  >
                    {ele.cardInfo.text}
                  </p>
                  <img
                    src={ele.cardInfo.image}
                    style={{
                      width: '96px',
                      height: '70px',
                      paddingRight: '12px',
                    }}
                  />
                </div>
              </div>
            </div>
            <div
              className="p-16px flex flex-row items-center justify-center cursor-pointer"
              onClick={() => {
                if (ele.cardDirective.actionType === 'pwa-redirection') {
                  const link = ele.cardDirective.elements[0].redirectTo;
                  window.location.assign(link);
                }
              }}
            >
              <ThemedIcon
                src={DependantIcon}
                style={{ width: '20px', height: '20px', marginRight: '4px' }}
              />
              <p
                style={{
                  color: 'var(--primary-button, #714fff)',
                  fontSize: '14px',
                  fontWeight: '600',
                }}
              >
                Manage Now
              </p>
            </div>
          </AdditionalCard>
        </AdditionalCardContainer>
      );
    };

    const renderHtmlCards = (ele, idx) => {
      let url;
      let openInSameTab = false;
      try {
        if ((ele.cardDirective.action || {}).redirectTo) {
          url = new URL((ele.cardDirective.action || {}).redirectTo);
          openInSameTab = (ele.cardDirective.action || {}).openInSameTab;
        }
      } catch (err) {
        console.error(err);
      }
      if (ele.link) {
        const imageSrc = ele?.link?.split('=')?.[1];
        if (!imageSrc) return null;
        return (
          <div
            // className="border border-txtsecondary-shades7 bg-textbox rounded-8 cursor-pointer"
            className="cursor-pointer mx-auto"
            onClick={() => {
              if (url && !openInSameTab) {
                window.open(url, '_blank');
              } else if (url) {
                window.location.assign(url);
              }
            }}
          >
            <img
              src={imageSrc}
              style={{ height: '40%', width: '100%', objectFit: 'contain' }}
              alt={ele.cardKey || 'html-card'}
              onClick={() => {
                switch (ele.cardDirective?.action?.redirectTo) {
                  case 'offline-prebook-flow':
                    this.props.history.push('/consultation/steps-overview', {
                      card: 'pre-book-appointment',
                    });
                    break;
                  case 'lead-ahc-packages':
                    this.props.history.push('/lab-test/ahcAllPackages');
                    break;
                  default:
                    return null;
                }
              }}
            />
          </div>
        );
      }
      return;
    };

    const renderCultCard = (card) => {
      const {
        action: { redirectTo, userDetails, redirectUrl },
        planDetails,
      } = card?.cardDirective;
      return (
        <div
          // className="border border-txtsecondary-shades7 bg-textbox rounded-8 cursor-pointer"
          className="cursor-pointer mt-16px mx-auto"
        >
          <img
            src={card?.link}
            style={{ height: '40%', width: '100%', objectFit: 'contain' }}
            alt={card.cardType}
            onClick={() =>
              this.handleCultClick(
                redirectTo?.toLowerCase(),
                userDetails,
                planDetails,
                redirectUrl
              )
            }
          />
        </div>
      );
    };

    const renderHealthContent = (cards) => {
      const card = cards[0];
      switch (card.cardType) {
        case 'sym-check':
          return (
            <AdditionalCardContainer>
              <AdditionalCard>
                <div className="border-b border-customE5E9FE w-full">
                  <div
                    className="flex flex-row items-center justify-between w-full pl-20px pb-5px"
                    style={{ paddingRight: '39px', paddingTop: '13px' }}
                  >
                    <div>
                      <div className="pt-18px">
                        <p
                          style={{
                            color: '#2D2066',
                            fontSize: '14px',
                            fontWeight: '600',
                            letterSpacing: '0.25px',
                          }}
                        >
                          {card.label}
                        </p>
                      </div>
                      <div className="mt-5px" style={{ paddingBottom: '22px' }}>
                        <p
                          style={{
                            fontSize: '12px',
                            color: '#767787',
                            textAlign: 'start',
                            marginRight: '34px',
                            lineHeight: '150%',
                            fontWeight: '400',
                          }}
                        >
                          {card.description}
                        </p>
                      </div>
                    </div>
                    <div>
                      <img
                        src={CheckSymptomsIcon}
                        style={{
                          width: '75px',
                          height: '90px',
                          paddingRight: '12px',
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div
                  className="p-16px flex flex-row items-center justify-center cursor-pointer"
                  onClick={() => this.runAction(card)}
                >
                  <p
                    style={{
                      color: 'var(--primary-button, #714fff)',
                      fontSize: '14px',
                      fontWeight: '600',
                    }}
                  >
                    Check Now
                  </p>
                </div>
              </AdditionalCard>
            </AdditionalCardContainer>
          );
        default:
          return null;
      }
    };

    const renderConsoleCards = (card) => {
      switch (card.cardType) {
        case 'hospitalisation':
          return (
            <div className="flex justify-center items-center">
              <NewHomeActionCard
                iconType={card.cardType}
                title={card?.displayLabel || 'Hospitalisation'}
                // offer={card.offer}
                onTap={() => {
                  logEvent('hospitalisation-request');
                  this.showHospitalization(card);
                }}
              />
            </div>
          );
        case 'reimbursement':
          return (
            <div className="flex justify-center items-center">
              <NewHomeActionCard
                iconType={card.cardType}
                title={card?.displayLabel || 'Reimbursements'}
                // offer={card.offer}
                onTap={() => this.requestReimbursement(card)}
              />
            </div>
          );
        case 'online-consults':
          return (
            <div className="flex justify-center items-center">
              <NewHomeActionCard
                iconType={card.cardType}
                title={card?.displayLabel || 'Online Consultations'}
                offer={card.offer}
                onTap={() => {
                  this.startTreament(
                    card.allowSearch,
                    this.state.blockers.pendingConsultationId,
                    this.state.blockers.cancelledRequest
                  );
                }}
              />
            </div>
          );
        case 'offline-consults':
          return (
            <div className="flex justify-center items-center">
              <NewHomeActionCard
                iconType={card.cardType}
                title={card?.displayLabel || 'Clinic Appointment'}
                offer={card.offer}
                onTap={() =>
                  this.findSpecialist(
                    card.pendingConsult,
                    card.cancelledRequest
                  )
                }
              />
            </div>
          );
        case 'pharmacy':
          return (
            <div className="flex justify-center items-center">
              <NewHomeActionCard
                iconType={card.cardType}
                title={card?.displayLabel || 'Medicine Delivery'}
                offer={card.offer}
                onTap={() => this.medicineOrder(card)}
              />
            </div>
          );
        case 'diagnostics':
          return (
            <div className="flex justify-center items-center">
              <NewHomeActionCard
                iconType={card.cardType}
                title={card?.displayLabel || 'Lab Tests'}
                offer={card.offer}
                onTap={this.bookTests}
              />
            </div>
          );
        case 'hra-card':
          return (
            <>
              {!hraDownloadableLink && (
                <div className="flex justify-center items-center">
                  <NewHomeActionCard
                    iconType={card.cardType}
                    title={card?.displayLabel || 'Health Risk Assessment'}
                    offer={card.offer}
                    onTap={() => this.props.history.push('/hra')}
                  />
                </div>
              )}
            </>
          );
        case 'cashless-vaccination':
          return (
            <div className="flex justify-center items-center">
              <NewHomeActionCard
                iconType={card.cardType}
                title={card?.displayLabel ? card?.displayLabel : card.label}
                offer={card.offer}
                onTap={() => this.myCashlessVaccination(card)}
              />
            </div>
          );
        case 'html':
          return (
            <>
              {card.icon === 'enrollment' &&
                Boolean(card?.cardDirective?.action?.redirectTo) && (
                  <div className="flex justify-center items-center">
                    <NewHomeActionCard
                      iconType={card.icon}
                      title={card.label}
                      offer={card.offer}
                      onTap={() => {
                        if (card?.cardDirective?.action?.redirectTo)
                          window.open(
                            card.cardDirective.action.redirectTo,
                            '_blank'
                          );
                      }}
                    />
                  </div>
                )}
            </>
          );
        case 'network-hospital-list':
          return (
            <div className="flex justify-center items-center">
              <NewHomeActionCard
                iconType={card.cardType}
                title={card?.displayLabel || 'Hospital Network'}
                offer={card.offer}
                onTap={() => history.push('./hospitalization/hospitals-list')}
              />
            </div>
          );
        case 'cashless-dental':
          return (
            <div className="flex justify-center items-center">
              <NewHomeActionCard
                iconType={card.cardType}
                title={card?.displayLabel || 'Cashless Dental'}
                offer={card.offer}
                onTap={() => {
                  this.findDentist();
                }}
              />
            </div>
          );
        case 'cashless-vision':
          return (
            <div className="flex justify-center items-center">
              <NewHomeActionCard
                iconType={card.cardType}
                title={card?.displayLabel || 'Cashless Vision'}
                offer={card.offer}
                onTap={() => {
                  history.push('/vision/preview');
                }}
              />
            </div>
          );
        case 'pb-opd-reimbursement':
          return (
            <div className="flex justify-center items-center">
              <NewHomeActionCard
                iconType={card.cardType}
                title={card?.displayLabel || 'OPD Claim Reimbursement'}
                offer={card.offer}
                onTap={() => {
                  logEvent('opd-claim-request');
                  this.showOPDClaim(card);
                }}
              />
            </div>
          );
        case 'cashless-physio':
          return (
            <div className="flex justify-center items-center">
              <NewHomeActionCard
                iconType={card.cardType}
                title={card?.displayLabel || 'Cashless Physiotherapy'}
                onTap={this.bookCashlessPhysio}
              />
            </div>
          );
        default:
          return null;
      }
    };

    const renderHcpCard = (ele) => {
      let url;
      let openInSameTab = false;
      if (!ele) return;
      try {
        if ((ele.cardDirective.action || {}).redirectTo) {
          url = new URL((ele.cardDirective.action || {}).redirectTo);
          openInSameTab = (ele.cardDirective.action || {}).openInSameTab;
        }
      } catch (err) {
        console.error(err);
      }
      if (ele.cardType === 'html' && ele.link) {
        return (
          <div
            className="cursor-pointer mx-auto p-4"
            onClick={() => {
              if (url && !openInSameTab) {
                window.open(url, '_blank');
              } else if (url) {
                logEvent('Home Tab Screen- HCP Card');
                this.props.history.push('/hcp/home', { pwa: true });
              }
            }}
          >
            <img src={ele.link.split('imageLink=')[1]} alt="hcp" />
          </div>
        );
      }
    };

    return (
      <>
        <FadeInTransition
          in={true}
          timeout={200}
          mountOnEnter
          unmountOnExit
          appear
        >
          <>
            {dashboardApiLoaded ? (
              <BodyContainer>
                {myntraSponsorId.includes(Number(this.props.sponsorId)) ? (
                  this.props.user?.sponsorId ? (
                    <div className="flex flex-col border-b-8 border-txtsecondary-shades7 p-4 gap-4">
                      <SubHeadings>Services</SubHeadings>
                      <div className="grid grid-cols-2 gap-4">
                        {consoleCards?.map(renderConsoleCards)}
                      </div>
                    </div>
                  ) : (
                    <AdditionalCards />
                  )
                ) : (
                  <></>
                )}
                {this.props?.config?.ahcOnTop && ahcCard?.length > 0 && (
                  <div className="border-b-8 border-txtsecondary-shades7 px-4 pt-4 mb-0 pb-10px">
                    {ahcCard.map(renderAhcCard)}
                  </div>
                )}
                {!myntraSponsorId.includes(Number(this.props.sponsorId)) ? (
                  this.props.user?.sponsorId ? (
                    <div className="flex flex-col border-b-8 border-txtsecondary-shades7 p-4 gap-4">
                      <SubHeadings>Services</SubHeadings>
                      <div className="grid grid-cols-2 gap-4">
                        {consoleCards?.map(renderConsoleCards)}
                      </div>
                    </div>
                  ) : (
                    <AdditionalCards />
                  )
                ) : (
                  <></>
                )}
                {myntraSponsorId.includes(Number(this.props.sponsorId)) &&
                  ahcCards?.cards?.[0]?.packages.length > 0 && (
                    <div className="p-4 border-b-8 border-txtsecondary-shades7 ">
                      <div className="flex items-center justify-between mb-20px">
                        <div className="text-txtlight font-semibold text-title-m">
                          {ahcCards.title}
                        </div>
                        <AHCHead2
                          onClick={() => {
                            this.props.history.push(
                              '/lab-test/ahcAllPackages',
                              {
                                packages: ahcCards,
                              }
                            );
                          }}
                          className="cursor-pointer"
                        >
                          <p
                            style={{ marginRight: '5px' }}
                            onClick={() =>
                              logEvent('Funnel Native AHC View All Clicked')
                            }
                          >
                            View all
                          </p>
                          <img src={RightBackIcon} alt="next" />
                        </AHCHead2>
                      </div>
                      <div className="grid grid-cols-2 gap-4">
                        {ahcCards.cards?.[0]?.packages
                          ?.slice(0, 4)
                          .map(renderAhcCards)}
                      </div>
                    </div>
                  )}

                {myntraSponsorId.includes(Number(this.props.sponsorId)) &&
                  additionalCards?.length > 0 && (
                    <div
                      style={{
                        paddingTop: '12px',
                        paddingBottom: '12px',
                        borderBottom: '8px solid #EDEDF0',
                      }}
                    >
                      {additionalCards.map(renderAdditionalCards)}
                    </div>
                  )}

                {myntraSponsorId.includes(Number(this.props.sponsorId)) &&
                cultCard?.cardDirective?.action?.redirectTo?.toLowerCase() !==
                  'planselection' &&
                cultCard ? (
                  <div className="p-4 border-b-8 border-txtsecondary-shades7">
                    {renderCultCard(cultCard)}
                  </div>
                ) : null}

                {myntraSponsorId.includes(Number(this.props.sponsorId)) &&
                  subscriptionCards.length > 0 && (
                    <div className="mt-20px border-b-8 border-txtsecondary-shades7 p-4 flex items-center flex-col gap-16px">
                      {renderSubscriptionCards(subscriptionCards)}
                    </div>
                  )}

                {importantLinksNew?.cards?.length > 0 && (
                  <ImportantLinksGrid
                    title={
                      importantLinksNew.showTitle && importantLinksNew.title
                    }
                    cards={importantLinksNew.cards}
                    onCardClick={(card) => this.handleImportantLinkClick(card)}
                  />
                )}

                {policyCards.length > 0 && (
                  <EcardsContainer policyCards={policyCards} />
                )}

                {axisSupportCard?.length > 0 && (
                  <ContactSupport ele={axisSupportCard} />
                )}
                {!myntraSponsorId.includes(Number(this.props.sponsorId)) &&
                  additionalCards?.length > 0 && (
                    <div
                      style={{
                        paddingTop: '12px',
                        paddingBottom: '12px',
                        borderBottom: '8px solid #EDEDF0',
                      }}
                    >
                      {additionalCards.map(renderAdditionalCards)}
                    </div>
                  )}
                {!myntraSponsorId.includes(Number(this.props.sponsorId)) &&
                  ahcCards?.cards?.[0]?.packages.length > 0 && (
                    <div className="p-4 border-b-8 border-txtsecondary-shades7 ">
                      <div className="flex items-center justify-between mb-20px">
                        <div className="text-txtlight font-semibold text-title-m">
                          {ahcCards.title}
                        </div>
                        <AHCHead2
                          onClick={() => {
                            this.props.history.push(
                              '/lab-test/ahcAllPackages',
                              {
                                packages: ahcCards,
                              }
                            );
                          }}
                          className="cursor-pointer"
                        >
                          <p
                            style={{ marginRight: '5px' }}
                            onClick={() =>
                              logEvent('Funnel Native AHC View All Clicked')
                            }
                          >
                            View all
                          </p>
                          <img src={RightBackIcon} alt="next" />
                        </AHCHead2>
                      </div>
                      <div className="grid grid-cols-2 gap-4">
                        {ahcCards.cards?.[0]?.packages
                          ?.slice(0, 4)
                          .map(renderAhcCards)}
                      </div>
                    </div>
                  )}
                {upgradeOrderPackagesList?.length > 0 && (
                  <div
                    className=""
                    style={{ marginTop: '4%', maxWidth: '420px' }}
                  >
                    <AHCheader>
                      <AHCHeadText>Packages for you</AHCHeadText>
                      {/* <AHCHead2
                      onClick={() =>
                        this.props.history.push('/lab-test/ahcAllPackages', {
                          packages: upgradeOrderPackages,
                        })
                      }
                      className="cursor-pointer"
                    >
                      <p style={{ marginRight: '5px' }}>View all</p>
                      <img src={RightBackIcon} alt="next" />
                    </AHCHead2> */}
                    </AHCheader>
                    <CardScrollContainer>
                      {upgradeOrderPackagesList?.map(renderUpSellCards)}
                    </CardScrollContainer>
                  </div>
                )}
                {(block.prescriptionVerificationStatus === 'upload' ||
                  block.prescriptionVerificationStatus === 'rejected') &&
                  showBlockerModal &&
                  isPrescriptionPopUpOpen && (
                    <PrescriptionPopup
                      data={blockerPopups[0].cardDirective.data[0]}
                      showModal={showBlockerModal}
                      closeModal={() => {
                        this.setState({ showBlockerModal: false });
                        dispatch(togglePrescriptionPopup(false));
                      }}
                    />
                  )}
                {(() => {
                  const supportCards = (popUpCardData || []).filter(
                    (c) =>
                      c.type === 'support-rating' ||
                      c.type === 'support-replied'
                  );
                  const isPrescriptionSlide =
                    block &&
                    (block.prescriptionVerificationStatus === 'upload' ||
                      block.prescriptionVerificationStatus === 'rejected') &&
                    showSnackBar;
                  const isFeedbackSlide =
                    this.state.showFeedbackSnackbar &&
                    !this.state.showFeedbackBottomSheet;
                  if (
                    !isPrescriptionSlide &&
                    !isFeedbackSlide &&
                    supportCards.length === 0
                  ) {
                    return null;
                  }
                  return (
                    <SnackBar
                      data={
                        isPrescriptionSlide
                          ? blockerPopups[0]?.cardDirective?.data[0]
                          : undefined
                      }
                      showModal={true}
                      closeModal={
                        isPrescriptionSlide
                          ? () => this.setState({ showSnackBar: false })
                          : undefined
                      }
                      feedbackData={
                        isFeedbackSlide ? this.state.claimFeedbackData : null
                      }
                      onFeedbackTap={this.handleFeedbackSnackbarTap}
                      onFeedbackDismiss={this.handleFeedbackSnackbarDismiss}
                      supportCards={supportCards}
                      onSupportTap={this.openTicketingSupport}
                    />
                  );
                })()}
                {htmlCards?.length > 0 && (
                  <div className="border-b-8 border-txtsecondary-shades7 p-4">
                    {htmlCards.map(renderHtmlCards)}
                  </div>
                )}
                <UpsellBookingFlowModals ref={this.upsellBookingFlowRef} />
                {!myntraSponsorId.includes(Number(this.props.sponsorId)) &&
                cultCard?.cardDirective?.action?.redirectTo?.toLowerCase() !==
                  'planselection' &&
                cultCard ? (
                  <div className="p-4 border-b-8 border-txtsecondary-shades7">
                    {renderCultCard(cultCard)}
                  </div>
                ) : null}
                <EAPSection eapCards={this.state.eapCards} />
                {showWaterTracking && (
                  <div
                    style={{
                      paddingTop: '16px',
                      borderBottom: `${
                        (htmlCards && htmlCards.length > 0) ||
                        (ahcCard && ahcCard.length > 0) ||
                        (symptomsCard && symptomsCard.length > 0) ||
                        (healthContentCards && !!healthContentCards.length)
                          ? '8px solid #EDEDF0'
                          : ''
                      }`,
                    }}
                  >
                    <WaterLogCard authToken={authToken} history={history} />
                  </div>
                )}
                {dependentCards && (
                  <DependentCard dependentCards={dependentCards} />
                )}
                {hcpCard && renderHcpCard(hcpCard)}
                {!this.props.config.ahcOnTop && ahcCard?.length > 0 && (
                  <div className="p-4 border-b-8 border-txtsecondary-shades7 mt-10px">
                    {ahcCard.map(renderAhcCard)}
                  </div>
                )}
                {!myntraSponsorId.includes(Number(this.props.sponsorId)) &&
                  subscriptionCards.length > 0 && (
                    <div className="mt-20px border-b-8 border-txtsecondary-shades7 p-4 flex items-center flex-col gap-16px">
                      {renderSubscriptionCards(subscriptionCards)}
                    </div>
                  )}
                {showHra ? (
                  hraDownloadableLink ? (
                    <HRACard link={hraDownloadableLink} />
                  ) : null
                ) : null}
                {symptomsCard && symptomsCard.length > 0 && (
                  <div
                    className="mt-20px pt-20px"
                    style={{
                      borderTop: `${
                        htmlCards.length > 0 || ahcCard.length > 0
                          ? '2px solid #E6E9EC'
                          : ''
                      }`,
                      width: '90%',
                      marginLeft: '5%',
                    }}
                  >
                    <SubHeadings
                      style={{ marginLeft: '10px', marginTop: '0px' }}
                    >
                      My Symptoms
                    </SubHeadings>
                    {renderHealthContent(symptomsCard)}
                  </div>
                )}
                {/* <div
                className="flex items-center mx-18px"
                style={{
                  padding: '17px',
                  gap: '1rem',
                  borderRadius: '12px',
                  marginTop: '20px',
                  cursor: 'pointer',
                  background: `linear-gradient(to right, var(--primary-button, #714fff) 100%, #4F80FF 100%)`,
                }}
                onClick={() =>
                  this.props.history.push('/hcp/home', {
                    coachPlan: true,
                    regenerateDietPlan: false,
                  })
                }
              >
                <div>
                  <img src={Nutrition} height={40} width={40} alt=""/>
                </div>
                <div
                  className="font-semibold"
                  style={{
                    color: 'white',
                    fontSize: '14px',
                    fontWeight: '600',
                  }}
                >
                  Customize your Diet Plan
                </div>
              </div> */}
                {/* <div className="mt-20px mx-18px">
                <Card
                  className="w-half mt-2"
                  onClick={() =>
                    this.props.history.push('/health-content/health-data', {
                      openModal: true,
                    })
                  }
                >
                  <div
                    className="flex justify-start p-15 items-center"
                    style={{ paddingBottom: '0' }}
                  >
                    <img
                      src={HealthDataIcon}
                      alt="health-data-icon"
                      width={'20px'}
                      height={'20px'}
                    />
                    <h4 className="text-caption-l font-semibold ml-8px">
                      Health Data
                    </h4>
                  </div>
                  <div
                    className="mt-16px mb-8px flex justify-between"
                    style={{ paddingLeft: '15px', paddingRight: '15px' }}
                  >
                    <div>
                      <p className="text-body-l text-txtlight font-semibold">
                        Monitor your health
                      </p>
                      <p className="text-body-l text-sub">
                        Check your logs over time
                      </p>
                    </div>
                    <img src={HealthDataHero} alt="" />
                  </div>
                  <div className="cursor-pointer font-semibold text-body-l text-primary flex items-start justify-center py-16px border-t border-solid border-txtsecondary-shades7">
                    Log Health Data
                  </div>
                </Card>
              </div> */}
                {!!healthContentCards.length && (
                  <div
                    style={{
                      borderTop: `${
                        htmlCards.length > 0 ||
                        hraDownloadableLink ||
                        ahcCard.length > 0
                          ? '2px solid #E6E9EC'
                          : ''
                      }`,
                      margin: '0 20px',
                      marginTop: '20px',
                    }}
                  >
                    <SubHeadings
                      style={{
                        marginLeft: '10px',
                        marginTop: '20px',
                        marginBottom: '10px',
                      }}
                    >
                      Health Content
                    </SubHeadings>
                    <div className="px-10px">
                      {renderHealthContentCards(healthContentCards)}
                    </div>
                  </div>
                )}
                {enrollmentCard && enrollmentCard.length > 0
                  ? enrollmentCard.map(renderEnrollmentCard)
                  : ''}
                {this.state.showGymCard && (
                  <GymHomeCard cultPass={cultPass}></GymHomeCard>
                )}
                {inviteCards.map(renderInviteCard)}
              </BodyContainer>
            ) : (
              <LoadingSkeleton n={6} />
            )}
            {showModal && (
              <Modal>
                <ModalContainer>
                  <FlyInTransition
                    in={modalVisible}
                    mountOnEnter
                    unmountOnExit
                    onExited={this.hideModal}
                    appear
                  >
                    <ModalBody>
                      <CloseContainer onTap={this.closeModal}>
                        <CloseIcon />
                      </CloseContainer>
                      <GiftImage src={giftIcon} />
                      <LineSeparator src={fitcoinLine} />
                      <ModalTitle>Introducing FIT Coins</ModalTitle>
                      <StepsContainer>
                        <StepContainer>
                          <StepNumber>1</StepNumber>
                          <StepTextContainer>
                            <StepTextTile>Complete transactions</StepTextTile>
                            <StepTextSubtitle>
                              Book consultations, order medicines & Lab tests
                              via VISIT App
                            </StepTextSubtitle>
                          </StepTextContainer>
                        </StepContainer>
                        <StepContainer>
                          <StepNumber>2</StepNumber>
                          <StepTextContainer>
                            <StepTextTile>Earn FIT Coins</StepTextTile>
                            <StepTextSubtitle>
                              For every successful transaction, you earn upto
                              1000 FITCoins
                            </StepTextSubtitle>
                            <StepTextSubtitleContainer>
                              <StepTextSubtitle>
                                Spending ₹ 1 = 1{' '}
                              </StepTextSubtitle>
                              <FitcoinIcon src={fitcoinIconWhite} />
                            </StepTextSubtitleContainer>
                          </StepTextContainer>
                        </StepContainer>
                        <StepContainer>
                          <StepNumber>3</StepNumber>
                          <StepTextContainer>
                            <StepTextTile>Claim your rewards</StepTextTile>
                            <StepTextSubtitle>
                              Spend your FITcoins to claim vouchers, Phonepe
                              Cash and more offers.
                            </StepTextSubtitle>
                          </StepTextContainer>
                        </StepContainer>
                      </StepsContainer>
                      <FitcoinButton onTap={this.openRewards}>
                        <ButtonText>SEE REWARDS</ButtonText>
                      </FitcoinButton>
                    </ModalBody>
                  </FlyInTransition>
                  <FlyInTransition
                    in={showPendingConsultBlocker}
                    mountOnEnter
                    unmountOnExit
                    onExited={this.hideModal}
                    appear
                  >
                    <UploadPrescription
                      doctorId={pendingConsult.doctorId}
                      consultationId={pendingConsult.consultationId}
                      doctorImg={pendingConsult.doctorImg}
                      doctorName={pendingConsult.doctorName}
                      dateLabel={pendingConsult.dateLabel}
                      onClose={this.closeUploadModal}
                      onSubmit={this.submitUploadModal}
                    />
                  </FlyInTransition>
                </ModalContainer>
              </Modal>
            )}
            {showHospitalizationModal && (
              <Modal>
                <HospitalizationModalContainer
                  onClick={this.handleOutsideClick}
                >
                  <FadeInTransition
                    in={showPendingHospilationBlocker}
                    mountOnEnter
                    unmountOnExit
                    onExited={this.hideModal}
                    appear
                  >
                    <div
                      ref={(node) => (this.node = node)}
                      className="bg-textbox flex flex-col items-center justify-center rounded-12"
                      style={{ width: '90%', maxWidth: '400px' }}
                    >
                      <HospitalizationModal
                        title={'Hospitalization'}
                        method1={'Claim Reimbursement'}
                        tag1={
                          'Get reimbursed for your previous hospitalisation'
                        }
                        method2={'Cashless Intimation Request'}
                        tag2={'Go cashless for your treatment'}
                        method3="Pre-Post Hospitalisation Claim"
                        tag3="Get reimbursed for your consultation/lab tests"
                        history={history}
                        ecashless={ecashless}
                        showPrePost={showPrePostButton == 1 ? true : false}
                        showCashlessClaimButton={showCashlessClaimButton}
                        showReimbusementClaimButton={
                          showReimbusementClaimButton
                        }
                        hospitalisationKeys={hospitalisationKeys}
                        modalType={'hospitalization-reimbursement'}
                      />
                    </div>
                  </FadeInTransition>
                </HospitalizationModalContainer>
              </Modal>
            )}
            {claimChecklistCard && (
              <ClaimInstructionsModal
                instructions={claimChecklistCard.uploadInstructions}
                checklists={claimChecklistCard.checkListArr}
                onChecklistTap={(checklist) =>
                  dispatch(
                    openFileViewer({
                      contentUrl: checklist.docUrl,
                      type: 'pdf',
                      title: checklist.name,
                    })
                  )
                }
                onClose={() => this.setState({ claimChecklistCard: null })}
              />
            )}
            {showOPDClaimModal && (
              <Modal>
                <HospitalizationModalContainer
                  onClick={this.handleOutsideClick}
                >
                  <FadeInTransition
                    in={showPendingOPDClaimBlocker}
                    mountOnEnter
                    unmountOnExit
                    onExited={this.hideModal}
                    appear
                  >
                    <div
                      ref={(node) => (this.node = node)}
                      className="bg-textbox flex flex-col items-center justify-center rounded-12"
                      style={{ width: '90%', maxWidth: '400px' }}
                    >
                      <HospitalizationModal
                        title={'OPD Claim'}
                        method1={'Claim Reimbursement'}
                        tag1={
                          'Get reimbursed for your previous hospitalisation'
                        }
                        method2={'Cashless Intimation Request'}
                        tag2={'Go cashless for your treatment'}
                        method3="Pre-Post Hospitalisation Claim"
                        tag3="Get reimbursed for your consultation/lab tests"
                        history={history}
                        ecashless={ecashless}
                        showPrePost={showPrePostButton == 1 ? true : false}
                        showCashlessClaimButton={showCashlessClaimButton}
                        showReimbusementClaimButton={
                          showReimbusementClaimButton
                        }
                        hospitalisationKeys={hospitalisationKeys}
                        modalType={'opd-claim-reimbursement'}
                      />
                    </div>
                  </FadeInTransition>
                </HospitalizationModalContainer>
              </Modal>
            )}
            {showSwitchBenefitModal && (
              <Modal>
                <div className="modalContainer">
                  <FlyInTransition
                    in={showSwitchBenefitModal}
                    mountOnEnter
                    appear
                    onExited={() =>
                      dispatch({
                        type: 'SET_SHOW_SWITCH_BENEFIT_MODAL',
                        payload: false,
                      })
                    }
                  >
                    <div className="w-full modalBody flex items-center">
                      <SwitchBenefitModal
                        title="Switch Benefits"
                        title2="Link Benefits"
                        history={history}
                        entityId={entityId}
                        onSwitch={this.getConsoleApiResponse}
                      />
                    </div>
                  </FlyInTransition>
                </div>
              </Modal>
            )}
            {emailVerificationAvailable && (
              <Breadcrumb
                onClick={() => {
                  history.push('/link-new-benefit', {
                    showEmailSentModal: true,
                    backButtonState: 'home',
                    // responseData,
                  });
                }}
              >
                <BreadcrumbContainer>
                  <NotificationIcon src={notification} />
                  <BreadcrumbText>
                    Verify your email to activate benefits.
                  </BreadcrumbText>
                  <NavigationButton src={navigationButton} />
                </BreadcrumbContainer>
              </Breadcrumb>
            )}
            <DisclaimerPopup
              show={this.state.showDisclaimerPopup}
              onClose={() => this.setState({ showDisclaimerPopup: false })}
              disclaimerText={
                this.props.user?.loginMeta?.cashlessServicePromotionalBanner
              }
              mode="timer"
              timerSeconds={5}
            />
            {/* {nonFeedbackPopups.length > 0 && (
            <PopUpPillsContainer
              bottomOffset={snackBarVisible ? 60 : 0}
            >
              {nonFeedbackPopups.map(renderPopUpPill)}
            </PopUpPillsContainer>
          )} */}
            <ClaimFeedbackBottomSheet
              visible={this.state.showFeedbackBottomSheet}
              onClose={this.handleFeedbackBottomSheetClose}
              reviewOptions={this.state.claimFeedbackData?.reviewOptions}
              reimbursementId={
                this.state.claimFeedbackData?.claim?.reimbursementId
              }
              entryPoint="home_snackbar"
              onSubmitReview={this.handleFeedbackSubmit}
            />
            <GmcClaimsFeedbackBottomSheet
              visible={this.state.showGmcFeedbackBottomSheet}
              onClose={this.handleGmcFeedbackBottomSheetClose}
              reviewOptions={this.state.gmcFeedbackData?.reviewOptions}
              claimId={this.state.gmcFeedbackData?.claimId}
              entryPoint="home_snackbar"
              onSubmitReview={this.handleGmcFeedbackSubmit}
            />
            <SmartSummaryBottomSheet
              visible={this.state.showSmartSummarySheet}
              data={this.getSmartSummaryData()}
              onClose={this.handleSmartSummaryClose}
              onViewReport={this.handleSmartSummaryViewReport}
              onViewSupplements={this.handleSmartSummaryViewSupplements}
            />
          </>
        </FadeInTransition>
        {importantLinkModal?.card?.length > 0 && (
          <CardGridModal
            title={importantLinkModal.title}
            cards={importantLinkModal.card}
            onCardClick={(subCard) =>
              this.handleImportantLinkSubCardClick(subCard)
            }
            onClose={() => this.setState({ importantLinkModal: null })}
          />
        )}
        {nudgeModal && dashboardApiLoaded && !this.props.appError?.hasError && (
          <NudgeModal
            modal={nudgeModal}
            icon={
              nudgeModal.type === 'ahc' ? (
                <AhcNudgeIcon />
              ) : (
                <ConsultationNudgeIcon />
              )
            }
            onClose={() => this.setState({ nudgeModal: null })}
            onCta={() => {
              const n = this.state.nudgeModal;
              if (n?.type === 'ahc' && n.redirectUrl) {
                const url = new URL(n.redirectUrl);
                const rt = url.searchParams.get('rt');
                const params = url.searchParams.get('params') || '';
                if (rt) {
                  this.props.history.push(`/${rt}${params}`);
                } else {
                  openLinkInNewTab(n.redirectUrl);
                }
              } else if (n?.type === 'consultation' && n.verticalId) {
                this.props.history.push(
                  `/consultation/doctor-select?verticalId=${n.verticalId}`
                );
              }
              this.setState({ nudgeModal: null });
            }}
          />
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  loginState: state.app.loginState,
  authToken: state.user.authToken,
  userId: state.user.userId,
  user: state.user,
  showFitCoins: state.app.config.showFitCoins,
  sponsorLogo: state.app.config.sponsorLogo,
  showWaterTracking: state.app.config.showWaterTracking,
  showUnlockGymSession: state.user.showUnlockGymSession,
  showHra: state.app.config.showHra,
  isPrescriptionPopUpOpen: state.app.isPrescriptionPopUpOpen,
  showSwitchBenefitModal: state.app.showSwitchBenefitModal,
  emailVerificationAvailable:
    state.linkBenefits.responseData?.emailVerificationAvailable,
  entityId: state.app.config.entityId,
  config: state.app.config,
  sponsorId: state.user.sponsorId,
  appError: state.app.appError,
});

export default connect(mapStateToProps)(HomeContainer);
